




import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceStore} from "../../store";

@Component({
    name: "FreightServiceLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${FreightServiceStore.data[this.id]?.serviceCode} - ${FreightServiceStore.data[this.id]?.name}`;
    }
}
